// src/context/PriceContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const PriceContext = createContext();

const DEFAULT_CODES = [
  "USDTRY", "EURTRY", "XAUUSD", "ALTINTRY", "ONSTRY", "GRAMALTIN", "CEYREKALTIN", "YARIMALTIN", "TEKALTIN",
  "CEYREKALTINESKI", "YARIMALTINESKI", "TEKALTINESKI", "GREMSE", "GREMESEESKI", "ATA", "ATAESKI",
  "ATA5", "ATA5ESKI", "22AYAR", "14AYAR", "GBPTRY", "CHFTRY", "CADTRY", "SARTRY", "AUDTRY",
  "JPYTRY", "AEDTRY", "QARTRY", "MADTRY", "JODTRY", "KWDTRY", "CNYTRY", "ILSTRY", "RUBTRY",
  "BGNTRY", "OMRTRY", "DKKTRY", "SEKTRY", "NOKTRY", "ALTINGUMUS", "GUMUSTRY", "GUMUSUSD",
  "XAGUSD", "USDKG", "EURKG", "EURUSD", "GBPUSD", "USDCHF", "USDCAD", "AUDUSD", "USDJPY",
  "USDNOK", "USDSEK", "USDDKK", "USDSAR", "USDAED", "USDQAR", "USDMAD", "USDILS", "USDRUB",
  "USDBGN", "JODUSD", "KWDUSD", "OMRUSD", "XPTUSD", "PLATIN", "PALADYUM"
];

export const PriceProvider = ({ children }) => {
  const [prices, setPrices] = useState([]);
  const [systemTime, setSystemTime] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [desiredUnits, setDesiredUnits] = useState(DEFAULT_CODES);

  const fetchData = async () => {
    try {
      const url = 'https://ukba-kasa.vercel.app/api/prices';
      
      const res = await axios.get(url, {
        headers: {
          "Cache-Control": "no-cache",
          "Pragma": "no-cache",
          "Expires": "0",
        },
        timeout: 8000,
      });
      
      const payload = res?.data?.data || [];
      
      // KRİTİK DÜZELTME: API'den gelen kodları (örn. 'altintry') büyük harfe çeviriyoruz.
      const standardizedPayload = payload.map(item => {
          if (item.currencyCode) {
              return { ...item, currencyCode: item.currencyCode.toUpperCase() };
          }
          return item;
      });
      
      // Standartlaştırılmış veride arama yapıyoruz.
      const altinTry = standardizedPayload.find(p => p?.currencyCode === "ALTINTRY");
      const xauusd = standardizedPayload.find(p => p?.currencyCode === "XAUUSD");
      const usdtry = standardizedPayload.find(p => p?.currencyCode === "USDTRY");
      
      let finalPayload = standardizedPayload;
      
      if (!altinTry) {
        if (xauusd && usdtry && xauusd.buy && xauusd.sell && usdtry.buy && usdtry.sell) {
          
          finalPayload = [
            ...standardizedPayload,
            {
              currencyCode: "ALTINTRY",
              buy: xauusd.buy * usdtry.buy,
              sell: xauusd.sell * usdtry.sell,
              description: "Has Altın-Türk Lirası (Türetilmiş)"
            }
          ];
        } else {
          // Bu uyarıyı sadece hata ayıklama gerektiğinde tutabilirsiniz.
          // console.warn("ALTINTRY türetilemedi: XAUUSD veya USDTRY eksik");
        }
      }
      
      setPrices(finalPayload);
      setSystemTime(res?.data?.systemTime || null);
      setErrorMessage(null);
    } catch (error) {
      console.error("API Error:", error.message);
      // console.error("API Error Details:", error.response?.data || error); // Gereksiz detay
      setErrorMessage("Bağlantı hatası: Lütfen interneti kontrol edin veya biraz sonra deneyin.");
    }
  };

  useEffect(() => {
    fetchData();
    // 5 SANİYEDE 1 GÜNCELLEME
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, [desiredUnits]);

  return (
    <PriceContext.Provider value={{ prices, systemTime, errorMessage, desiredUnits, setDesiredUnits }}>
      {children}
    </PriceContext.Provider>
  );
};

export const usePriceContext = () => useContext(PriceContext);